<template>
  <div class="dashboard-alertes">
    <div class="box box-warning">
      <div class="overlay" v-if="loading">
        <i class="fa fa-refresh fa-spin"></i>
      </div>
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-exclamation-triangle"></i> Alertes &amp; Actions requises</h3>
        <button class="btn btn-default btn-xs pull-right" @click.prevent="loadAll()">
          <i class="fa fa-refresh"></i>
        </button>
      </div>
      <div class="box-body no-padding">
        <ul class="list-group list-group-flush dashboard-alerte-list">

          <!-- MEMBRES -->
          <li class="list-group-item list-group-item-header" v-if="hasMembreAlertes">
            <strong><i class="fa fa-users"></i> Membres</strong>
          </li>
          <li class="list-group-item alerte-item"
              v-for="alerte in alertesMembres"
              v-if="alerte.count > 0"
              :key="alerte.key">
            <router-link :to="{ name: 'Avertissements' }" class="alerte-link">
              <span class="alerte-icon" :class="'alerte-' + alerte.severity">
                <i :class="'fa fa-' + alerte.icon"></i>
              </span>
              <span class="alerte-label">{{ alerte.title }}</span>
              <span class="badge alerte-badge" :class="'bg-' + alerte.color">{{ alerte.count }}</span>
            </router-link>
          </li>

          <!-- CLUBS -->
          <li class="list-group-item list-group-item-header" v-if="hasClubAlertes || hasClubLoading">
            <strong><i class="fa fa-building"></i> Clubs</strong>
            <i class="fa fa-spinner fa-spin pull-right" style="color:#aaa;" v-if="hasClubLoading"></i>
          </li>
          <li class="list-group-item alerte-item"
              v-for="alerte in alertesClubs"
              v-if="alerte.count > 0"
              :key="alerte.key">
            <router-link :to="{ name: 'Avertissements' }" class="alerte-link">
              <span class="alerte-icon" :class="'alerte-' + alerte.severity">
                <i :class="'fa fa-' + alerte.icon"></i>
              </span>
              <span class="alerte-label">{{ alerte.title }}</span>
              <span class="badge alerte-badge" :class="'bg-' + alerte.color">{{ alerte.count }}</span>
            </router-link>
          </li>

          <!-- RECAPS -->
          <li class="list-group-item list-group-item-header" v-if="hasRecapAlertes">
            <strong><i class="fa fa-file-text-o"></i> Récapitulatifs</strong>
          </li>
          <li class="list-group-item alerte-item"
              v-for="alerte in alertesRecaps"
              v-if="alerte.count > 0"
              :key="alerte.key">
            <router-link :to="{ name: 'Avertissements' }" class="alerte-link">
              <span class="alerte-icon" :class="'alerte-' + alerte.severity">
                <i :class="'fa fa-' + alerte.icon"></i>
              </span>
              <span class="alerte-label">{{ alerte.title }}</span>
              <span class="badge alerte-badge" :class="'bg-' + alerte.color">{{ alerte.count }}</span>
            </router-link>
          </li>

          <!-- AUCUNE ALERTE -->
          <li class="list-group-item text-center text-muted" v-if="!loading && !hasAnyLoading && totalAlertes === 0">
            <i class="fa fa-check-circle text-green"></i> Aucune alerte
          </li>
        </ul>
      </div>
      <div class="box-footer text-center" v-if="totalAlertes > 0">
        <router-link :to="{ name: 'Avertissements' }">
          Voir tous les avertissements <i class="fa fa-arrow-right"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
var moment = require('moment')

export default {
  data() {
    return {
      loading: false,
      alertesMembres: [
        {key: 'membresWithLicenceImpayeeOuIncomplete', title: 'Licences impayées ou incomplètes', icon: 'credit-card', severity: 'danger', color: 'red', count: 0, loading: false, param: null},
        {key: 'membresWithDoubleLicence', title: 'Doubles licences', icon: 'clone', severity: 'danger', color: 'red', count: 0, loading: false, param: null},
        {key: 'membresLicenciesButClubNotLicencie', title: 'Licenciés dans clubs non-licenciés', icon: 'chain-broken', severity: 'warning', color: 'yellow', count: 0, loading: false, param: null},
        {key: 'membresWithLicenceNonRecap', title: 'Licences non liées à un récap', icon: 'unlink', severity: 'warning', color: 'yellow', count: 0, loading: false, param: null},
        {key: 'membresPoomToDan', title: 'Poom à régulariser en Dan', icon: 'exchange', severity: 'info', color: 'aqua', count: 0, loading: false, param: null},
      ],
      alertesClubs: [
        {key: 'clubWithLicenceIncomplete', title: 'Cotisation non payée', icon: 'money', severity: 'danger', color: 'red', count: 0, loading: false, param: moment().year()},
        {key: 'clubAffilieAnneePasseePasMaintenant', title: 'Affiliés en ' + (moment().year() - 1) + ' mais pas en ' + moment().year(), icon: 'calendar-times-o', severity: 'danger', color: 'red', count: 0, loading: false, param: null},
        {key: 'clubWithLicenceButNoMembers', title: 'Clubs licenciés sans membres', icon: 'building-o', severity: 'warning', color: 'yellow', count: 0, loading: false, param: moment().year()},
        {key: 'clubWithoutCorrespondant', title: 'Clubs sans correspondant', icon: 'address-book-o', severity: 'warning', color: 'yellow', count: 0, loading: false, param: null},
        {key: 'clubMoniteurNotLicencied', title: 'Moniteur non licencié', icon: 'id-badge', severity: 'warning', color: 'yellow', count: 0, loading: false, param: null},
        {key: 'clubMoniteurNotDan', title: 'Moniteur non ceinture noire', icon: 'shield', severity: 'info', color: 'aqua', count: 0, loading: false, param: null},
      ],
      alertesRecaps: [
        {key: 'recapitulatifsEnAttentePayement', title: 'Récaps en attente de payement', icon: 'hourglass-half', severity: 'warning', color: 'yellow', count: 0, loading: false, param: null},
      ],
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    }),
    hasMembreAlertes() {
      return this.alertesMembres.some(a => a.count > 0)
    },
    hasClubAlertes() {
      return this.alertesClubs.some(a => a.count > 0)
    },
    hasClubLoading() {
      return this.alertesClubs.some(a => a.loading)
    },
    hasAnyLoading() {
      let all = [].concat(this.alertesMembres, this.alertesClubs, this.alertesRecaps)
      return all.some(a => a.loading)
    },
    hasRecapAlertes() {
      return this.alertesRecaps.some(a => a.count > 0)
    },
    totalAlertes() {
      let total = 0
      this.alertesMembres.forEach(a => total += a.count)
      this.alertesClubs.forEach(a => total += a.count)
      this.alertesRecaps.forEach(a => total += a.count)
      return total
    }
  },
  mounted() {
    this.loadAll()
  },
  methods: {
    loadAll() {
      this.loading = true
      let allAlertes = [].concat(this.alertesMembres, this.alertesClubs, this.alertesRecaps)
      let responded = 0
      allAlertes.forEach(alerte => {
        alerte.loading = true
        let url = this.getRoute('Avertissement.' + alerte.key)
        if (alerte.param != null) {
          url += alerte.param
        }
        this.$http.get(url).then((response) => {
          alerte.count = Array.isArray(response.body) ? response.body.length : 0
          alerte.loading = false
          responded++
          if (responded >= 1) this.loading = false
        }, () => {
          alerte.count = 0
          alerte.loading = false
          responded++
          if (responded >= 1) this.loading = false
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DashboardAlertes.vue